import React from "react";
import "./timeline-modern.css";

export default function Time({data=[]}) {
  const groups = [...data].filter(item => Number.isFinite(Number(item.Year))).sort((a,b)=>Number(b.Year)-Number(a.Year) || Number(a.id)-Number(b.id));
  return <section className="lok-history-timeline" aria-label="Lokarpan history timeline">
    {groups.map(item => {
      const events = [1,2,3,4,5,6].filter(i => item["Headline"+i]?.trim()).map(i => ({index:i,heading:item["Headline"+i],description:item["Description"+i],image:item["Picture"+i]}));
      return <div className="lok-history-year" id={"timeline-year-"+item.Year} key={item.id || item.Year}>
        <h2 className="lok-history-year-label">{item.Year}</h2>
        <div className="lok-history-events">{events.map(event => <article className="lok-history-event" key={event.index}>
          <div className="lok-history-event-content"><h3>{event.heading}</h3>{event.description && <p>{event.description}</p>}</div>
          {event.image && <div className="lok-history-event-media"><img loading="lazy" src={event.image} alt={event.heading}/></div>}
        </article>)}</div>
      </div>;
    })}
  </section>;
}
